export const educationData = [
    {
        id: 1,
        institution: 'BITS Pilani- Hyderabad Campus',
        course: 'BE E.C.E',
        startYear: '2021',
        endYear: 'Present (2025)'
    },
    {
        id: 2,
        institution: 'P.N. College, Pusad',
        course: 'Higher Secondary Certificate (HSC)',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'Saint Marys English School',
        course: 'Secondary School Certificate (SSC)',
        startYear: '2007',
        endYear: '2019'
    },
]